import { hstDisqualifyingConditions, isHstDisqualifyingAnswer } from 'constants/cancellationReasons'
import { Order } from 'store/types'

// Patients who answered "yes" to any HST-disqualifying screening condition will not be
// tested (the order gets cancelled by the lab), so they must not be sent to Stripe.
export const isDisqualifiedForHst = (order?: Order): boolean =>
  hstDisqualifyingConditions.some((condition) =>
    isHstDisqualifyingAnswer(order?.hst?.paperwork?.data?.patient, condition.paperworkField),
  )

// The patient reported that the insurance on file is inaccurate, so the paperwork stops after the
// consent step. The lab clears this flag once the insurance has been reviewed and verified, and the
// patient gets a copay link by SMS to finish the payment step.
export const isInsuranceUnderReview = (order?: Order): boolean =>
  Boolean(order?.hst?.paperwork?.meta?.insuranceCorrection)
